import React, { useContext, useEffect, useState } from 'react'

import Categories from '../../components/Categories'
import CarouselSwiper from '../../components/CarouselSwiper'
import NextButton from '../../components/NextButton'
import SelectedOffer from '../../components/SelectedOffer'
import MoreOptions from '../../components/MoreOptions'

import ClaroPayContext from '../../context/ClaroPayContext'

import Country from '../../constants/Country'
import { MENU_OPTION_PIDESALDO } from '../../constants/ClaroPayConstants'

import iconPideSaldo from '../../assets/img/menuIcon-PideSaldo.svg'
import iconWhatsAppPideSaldo from '../../assets/img/whatsapp-pideSaldo.png'

const ClaroPideSaldo = () => {
  const claroPayContext = useContext(ClaroPayContext)

  const { countryCode } = Country()

  const {
    getOnlyProducts,
    formatNumber,
    setOpcionSeleccionada,
    isLoading,
    products,
    codePideSaldo,
    sendMetrics,
    setCurrentCategoryMetrics,
  } = claroPayContext

  const [currentRealIndex, setCurrentRealIndex] = useState(0)
  const [activeSwiper, setActiveSwiper] = useState(false)
  const [code, setCode] = useState(undefined)
  const [isActive, setIsActive] = useState(false)

  useEffect(() => {
    if (isActive) {
      const timer = setTimeout(() => {
        setIsActive(false)
      }, 5000)

      return () => clearTimeout(timer)
    }
  }, [isActive])

  const [state, setState] = useState({
    packs: [],
    topup: [],
    bundle: [],
    pack: {
      amount: 0,
      currency: 0,
      subtitle: '',
      validity: '',
      socialMedia: { icons: [] },
      description: [],
      mainDescription: '',
    },
    currentCategory: 'bundle',
    selectedProduct: false,
  })

  useEffect(() => {
    setOpcionSeleccionada(MENU_OPTION_PIDESALDO)
    fetchProducts()
  }, [])

  const fetchProducts = async () => {
    try {
      const productsData = await getOnlyProducts()

      const arrProducts = productsData.products.map(product => ({
        ...product,
        amount: formatNumber(product.amount),
      }))

      let topup
      if (countryCode !== '504') {
        topup = arrProducts
          .filter(
            product =>
              product.productType === 'TOPUP' &&
              product.productId !== 'TOPUP200',
          )
          .toSorted((a, b) => b.amount - a.amount)
      } else {
        topup = arrProducts
          .filter(product => product.productType === 'TOPUP')
          .toSorted((a, b) => b.amount - a.amount)
      }

      const bundle = arrProducts
        .filter(product => product.productType === 'BUNDLE')
        .toSorted((a, b) => b.amount - a.amount)

      const pack = bundle[0]
      const packs = bundle
      const currentCategory = 'bundle'

      setState(prevState => ({
        ...prevState,
        bundle,
        topup,
        currentCategory,
        packs,
        pack,
      }))
      setActiveSwiper(true)
    } catch (error) {}
  }

  useEffect(() => {
    setCurrentCategoryMetrics('Paquetes-')
    const metricsData = {
      metricType: 'home',
      metricName: 'Home',
    }

    sendMetrics(metricsData)
    const metricsDataCategory = {
      metricType: 'category',
      metricName: 'Superpacks',
    }
    sendMetrics(metricsDataCategory)
  }, [])

  const handleSlideChange = swiper => {
    const newRealIndex = swiper.realIndex

    if (newRealIndex !== currentRealIndex) {
      setCurrentRealIndex(newRealIndex)

      const pack = state.packs[newRealIndex]

      setState(prevState => ({
        ...prevState,
        pack,
      }))
    }
  }

  const handleCategory = category => {
    setActiveSwiper(false)

    setCurrentRealIndex(0)
    setTimeout(() => {
      setActiveSwiper(true)
    }, 1)
    const packs = category === 'bundle' ? state.bundle : state.topup
    const metricsData = {
      metricType: 'category',
      metricName: category === 'bundle' ? 'Superpacks' : 'Recargas',
    }
    setCurrentCategoryMetrics(category === 'bundle' ? 'Paquetes-' : 'Recarga-')
    sendMetrics(metricsData)
    setState(prevState => ({
      ...prevState,
      currentCategory: category,
      packs,
      pack: packs[0],
    }))
  }

  const handleRedirectBanner = async () => {
    if (code) {
      const baseUrl = window.location.origin
      const rechargeUrl = `${baseUrl}/g?${code}`

      const message = `Hola!  Me quedé Sin Saldo, Me puedes recargar por favor…\n\nPresiona este link: ${rechargeUrl}\n\nMuchas gracias!`

      const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`

      window.open(whatsappUrl, '_blank')
      const metricsData = {
        metricType: 'Botón_WhatsApp',
        metricName: 'Botón_WhatsApp',
      }
      sendMetrics(metricsData)
    }
  }

  const handleSelectedProduct = async () => {
    setState(prevState => ({
      ...prevState,
      selectedProduct: !prevState.selectedProduct,
    }))
    if (state.selectedProduct) {
      setState(prevState => ({
        ...prevState,
        pack: packs[0],
      }))
      const metrics = {
        metricType: 'CheckOut_',
        metricName: 'MasOpciones',
      }
      sendMetrics(metrics)
      setCode(undefined)
      setIsActive(false)
    } else {
      const metrics = {
        metricType: 'BtnContinuar',
        metricName:
          'Botón_' +
          (state.currentCategory === 'bundle' ? 'Paquetes' : 'Recargas') +
          '_Continuar',
      }
      const code = await codePideSaldo(state.pack.productId)
      setCode(code)
      setIsActive(true)
      sendMetrics(metrics)
    }
  }

  const { currentCategory, pack, packs, bundle, selectedProduct } = state

  return (
    <>
      {!isLoading && products && (
        <div className="claro__container__pideSaldo">
          <div className="claro__container__pideSaldo__title">
            <img
              className="claro__container__pideSaldo__title__image"
              src={iconPideSaldo}
              alt="Pide Saldo"
            />
            <div className="claro__container__pideSaldo__title__text">
              Pide Saldo
            </div>
          </div>

          <div className="claro__container__pideSaldo__subtitle">
            A tu familiar o amigo Local o Internacional
          </div>

          {!selectedProduct ? (
            <>
              <Categories
                currentCategory={currentCategory}
                handleCategory={handleCategory}
                bundle={bundle}
              />

              {activeSwiper && (
                <CarouselSwiper
                  selectedProduct
                  handleSlideChange={handleSlideChange}
                  currentCategory={currentCategory}
                  pack={pack}
                  sendMetrics={sendMetrics}
                  packs={packs}
                />
              )}

              <NextButton
                textBtn="Continuar"
                onClick={handleSelectedProduct}
                enabled
                pideSaldo
              />
            </>
          ) : (
            <>
              <SelectedOffer currentCategory={currentCategory} pack={pack} />

              <MoreOptions handleSelectedProduct={handleSelectedProduct} />

              {code && (
                <div
                  onClick={handleRedirectBanner}
                  className={`claro__container__pideSaldo__banner ${
                    isActive ? 'animate-jump' : ''
                  }`}
                >
                  <div className="claro__container__pideSaldo__banner__text">
                    <div className="claro__container__pideSaldo__banner__text__title">
                      Presiona <strong>Aquí</strong> para Pedir una
                      Recarga/Paquete a tu Familiar/Amigo Local o en el
                      Extranjero
                    </div>
                  </div>
                  <div className="claro__container__pideSaldo__banner__icon">
                    <img src={iconWhatsAppPideSaldo} alt="Pide Saldo" />
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      )}
    </>
  )
}

export default ClaroPideSaldo
